import { MutationHookOptions, useMutation } from '@apollo/client';

import { UPDATE_CHILD } from './mutations';

export const useUpdateChild = (options?: MutationHookOptions) => useMutation(UPDATE_CHILD, options);
